const NodeRSA = require('node-rsa');

const timeConversion = (time, type, startTip, endTip, centerTip) => { // 时间转换器  time单位为秒  type 例如 yyyymmddhhmmss
  const date = new Date(time * 1000);
  const year = date.getFullYear();
  const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  const hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  const mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  const ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

  let types = type;
  types = String(types).toLowerCase();
  switch (types) {
    case 'yyyymmddhhmmss' : // 年月日时分秒
      return `${year}${startTip}${month}${startTip}${day}${centerTip || ' '}${hh}${endTip}${mm}${endTip}${ss}`;
    case 'yyyymmdd' : // 年月日
      return `${year}${startTip}${month}${startTip}${day}`;
    case 'mmdd' : // 月日
      return `${month}${startTip}${day}`;
    case 'hhmmss' : // 时分秒
      return `${hh}${endTip}${mm}${endTip}${ss}`;
    case 'yyyy-mm-dd hh:mm:ss' :
      return `${year}-${month}-${day} ${hh}:${mm}:${ss}`;
    case 'yyyy-mm-dd' :
      return `${year}-${month}-${day}`;
    case 'mm-dd' :
      return `${month}-${day}`;
    case 'mm-dd hh:mm:ss' :
      return `${month}-${day} ${hh}:${mm}:${ss}`;
    case 'hh:mm' :
      return `${hh}:${mm}`;
    case 'hh:mm:ss' :
      return `${hh}:${mm}:${ss}`;
    case 'mm-dd hh:mm' :
      return `${month}-${day} ${hh}:${mm}`;
    default :
      return `${year}-${month}-${day} ${hh}:${mm}:${ss}`;
  }
};
// 查询数据的时间戳单位秒 type 1开始时间 2结束时间
const queryDataTimestamp = (time, type) => {
  const date = new Date(time);
  const year = date.getFullYear();
  const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  const returnData = type === 1 ? `${year}-${month}-${day} 00:00:00` : `${year}-${month}-${day} 23:59:59`;
  return parseInt(new Date(returnData.replace(/-/g, '/')).getTime() / 1000);
};

const priKey = `-----BEGIN RSA PRIVATE KEY-----
MIICXAIBAAKBgQDvluFNiF8IrIsddK0OXBAvVBJH11OKvy9er1tRGn9yEJoHCJY3
EU/xz2LasCK8AwgRIqGJbvDBgRa70c3QT9j+wPqNqqJCSoSEKifnDUk1RgUReJT6
iqWaJyfM+WM3aHnKl61RZL4NV5qKe4CHMtaH/JtBCC/JzpuFER1P1IhCtQIDAQAB
AoGAaFYQb68/k4twWbeB1YsKEVJPU7HV08pGWrmKztr3PTk1mnKG2BxV8DwcFJg3
yCCZ1rx6FFuXxOzudYR8WIctO4wdsEbFky/cEGsfc6JJjiktmZaQ7MvobGNwnoFJ
QvRxDd+5uD87JE19iBSgUpLVtXbv+pZxSpD70vitnMdSctECQQD66Z5HsuC8DUPu
OLQHNN4ra5Op179Xlq7LiEFW4GaVgonw24kiLX23c7CK7295Rgxct1fwQKyuU9br
n2uj8toDAkEA9HJ85BWlm2OfUm6VI3Q99rjlpCnhRyz70+sEtf7if1SpctVxNTkX
UOnXlpPTohjAHNhzh9fa1hh/ySH9sRMu5wJAa//8uh3br/YBxFsx2lw+OPBQGe4c
lSXtzPu0LCHg5f/PQhYs28I696jbV6IiGFA3Z/0e4/HiohLCUp9HJMWWYwJACE53
pfyCUyRwfomZccn6bQ7dZtWxfQyvRgU/dLvDkJYc5/UO0sMs4qf/lnNRhrmWlaRZ
UK1qF0pf1ULdbw360wJBAObrYopW2kvIlE09j9SEgNtgVsmfZlf85c4EAZrFJP/T
8nMNKQGo92Gd3HvbjJ+ZBOP1IFt+FDAsXeSLWLAwJrg=
-----END RSA PRIVATE KEY-----`;

const decryptString = (str) => {
  const key = new NodeRSA(priKey);
  key.setOptions({ encryptionScheme: 'pkcs1' }); // 必须要显示指定
  return key.decrypt(str, 'utf-8');
};

export {
  timeConversion,
  queryDataTimestamp,
  decryptString
};
